import { Box, Spinner } from '@chakra-ui/react'
import React from 'react'

export function Loading() {
  return (
    <Box
      w="100%"
      minWidth={593}
      padding="20px"
      minHeight={300}
      borderRadius={15}
      position="relative"
      backgroundColor="#fff"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box h="50px" w="50px">
        <Spinner
          w="100%"
          h="100%"
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
        />
      </Box>
    </Box>
  )
}
